import { useMutationWithErrorHandler } from "@nens/ranalib";
import { getHCCApi } from "@nens/threedi/openapi-client";

import {
  useInvalidateHccSimulationTemplatesQuery,
  useUpdateHccSimulationTemplatesQuery,
} from "@/queries/query-hcc-simulation-templates";

export const useHccDeleteSimulationTemplateMutation = (threediModelId: number | undefined) => {
  const invalidateHccSimulationTemplatesQuery =
    useInvalidateHccSimulationTemplatesQuery(threediModelId);

  return useMutationWithErrorHandler(
    (templateId: number) => getHCCApi().simulationTemplatesDelete({ id: templateId }),
    {
      onSuccess: invalidateHccSimulationTemplatesQuery,
    }
  );
};

export const useHccRenameSimulationTemplateMutation = (threediModelId: number | undefined) => {
  const updateHccSimulationTemplatesQuery = useUpdateHccSimulationTemplatesQuery(threediModelId);
  return useMutationWithErrorHandler(
    ({ id, name }: { id: number; name: string }) =>
      getHCCApi().simulationTemplatesPartialUpdate({ id, data: { name } }),
    {
      // First args is returned data, second args is the variables passed to the mutation function
      onSuccess: ({ name }, { id }) => {
        updateHccSimulationTemplatesQuery({ id, name });
      },
    }
  );
};
